import { checkPointsDTO } from "../../shared/dtos/checkPointsDTO";
import MapDTO from "../../shared/dtos/mapDTO";
import UserRequestDTO from "../../shared/dtos/userRequestDTO";

export const getTripDestinations = (
  trip: UserRequestDTO | null | undefined,
): checkPointsDTO[] | undefined => {
  if (!trip?.destinations?.length) return;

  let tripDestinations: checkPointsDTO[] = [...trip.destinations];

  tripDestinations = tripDestinations.sort(
    (a: checkPointsDTO, b: checkPointsDTO) =>
      Number(a.requestSequence ?? a.id) - Number(b.requestSequence ?? b.id),
  );

  return tripDestinations.filter(
    (destination) => destination.latitude && destination.longitude,
  );
};

export const getDestinationsByUserRequestHelper = (
  userRequest: UserRequestDTO | null | undefined,
) => {
  if (!userRequest) return;
  const wayPoints: checkPointsDTO[] | undefined =
    getTripDestinations(userRequest);

  let lastWaypoint = {
    id: `${userRequest.id}DropOff`,
    destinationLatitude: userRequest.destinationLatitude,
    destinationLongitude: userRequest.destinationLongitude,
    destinationAddress: userRequest.destinationAddress,
  };

  if (wayPoints) {
    const lastIndex = wayPoints.length - 1;
    lastWaypoint = {
      id: `${wayPoints[lastIndex].id}DropOff`,
      destinationAddress: wayPoints[lastIndex].address,
      destinationLatitude: wayPoints[lastIndex].latitude,
      destinationLongitude: wayPoints[lastIndex].longitude,
    };
  }

  const response = {
    dropOff: lastWaypoint,
    pickUp: {
      id: `${userRequest.id}PickUp`,
      originLatitude: userRequest.originLatitude,
      originLongitude: userRequest.originLongitude,
      originAddress: userRequest.originAddress,
    },
  } as MapDTO;

  if (wayPoints?.length) {
    response.wayPoints = wayPoints;
  }

  return response;
};

export default getDestinationsByUserRequestHelper;
